import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { toastr } from 'react-redux-toastr';

import {
  addOnlineForm,
  getStorageSetting
} from 'actions';

import CustomerAccountInput, { CustomerAccountInputLayout } from 'components/Common/Inputs/CustomerAccountInput';
import OnlineForm from 'components/OnlineForms/OnlineForm';
import withContainerErrorBoundary from 'components/ErrorBoundaries/ContainerErrorBoundary/withContainerErrorBoundary';

class OnlineForms extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    const clients = this.filterClientList() || [];
    const clientKey = (clients != null && clients.length === 1) ? clients[0].key : '';

    this.state = {
      clientId: clientKey,
      customerAccount: null,
      formReference: '',
    };
  }

  onCustomerAccountChange(data) {
    this.setState({ customerAccount: data });
  }

  onFormReferenceChange = (e, newValue) => this.setState({ formReference: newValue });

  addOnlineForm = (formType) => {
    const { dispatch } = this.props;
    const { clientId, customerAccount, formReference } = this.state;

    if (!customerAccount) {
      toastr.error('', 'Please select a customer or create a new customer.');
      return;
    }
    if (!customerAccount.newCustomer && !customerAccount.customerId) {
      toastr.error('', 'Please provide a valid value for an existing customer or create a new one.');
      return;
    }
    if (!customerAccount.newAccount && (!customerAccount.accounts || customerAccount.accounts.length === 0)) {
      toastr.error('', 'Please provide a valid value for an existing account or create a new one.');
      return;
    }
    if (!customerAccount.legalEntities || customerAccount.legalEntities.length === 0) {
      toastr.error('', 'Please provide a valid value for an existing legal entity.');
      return;
    }
    const combinedAllowed = customerAccount.legalEntities.filter(le => (le.chapter4Status === 1 || le.chapter4Status === 2)).length === 0;
    if (formType && formType.includes('fatca_crs') && !combinedAllowed) {
      toastr.error('', 'Cannot enter FATCA/CRS Combined forms for legal entities which are US Withholding Agents. Please review the selected legal entities.');
      return;
    }
    const hasDualFormRequirement = customerAccount.legalEntities.filter(le => le.dualFormRequirement > 0).length > 0;
    if (formType && formType.includes('fatca_crs') && hasDualFormRequirement) {
      toastr.error('', 'Cannot enter FATCA/CRS Combined forms for legal entities which require Dual Forms. Please review the selected legal entities.');
      return;
    }
    if (!clientId) {
      toastr.error('', 'Please provide a valid value for an existing client.');
      return;
    }

    dispatch(addOnlineForm(formType, clientId, customerAccount, formReference));
  };

  // eslint-disable-next-line class-methods-use-this
  filterClientList = () => {
    const clients = getStorageSetting('clients') || [];
    const selectedClient = getStorageSetting('selectedClient');
    let filteredClientList = clients;

    if (selectedClient != null) {
      filteredClientList = [];
      filteredClientList.push(selectedClient);
    }

    return filteredClientList;
  };

  render() {
    const {
      clientId,
      formReference,
    } = this.state;

    return (
      <div className="online-forms">
        <form
          id="onlineForm"
          onSubmit={ values => this.addOnlineForm(values) }
          className="form-horizontal"
        >
          <div className="columns outer-box form-selection mb">
            <div className="form-group col-9 col-sm-12">
              <CustomerAccountInput
                clientId={ clientId || 0 }
                onSelectionChange={ data => this.onCustomerAccountChange(data) }
                layout={ CustomerAccountInputLayout.Horizontal }
              />
            </div>
            <div className="form-group col-3 col-sm-12">
              <div className="form-group col-12">
                <div className="col-5 col-sm-12 text-right">
                  <label htmlFor="formReference" className="form-label">Form Ref.</label>
                </div>
                <div className="col-7 col-sm-12">
                  <Field
                    id="formReference"
                    name="formReference"
                    component="input"
                    className="form-input"
                    value={ formReference }
                    onChange={ (e, newValue) => this.onFormReferenceChange(e, newValue) }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 outer-box">
            <div className="form"><OnlineForm handleClick={ this.addOnlineForm } formType="crse" title="CRS-E Form" /></div>
            <div className="form"><OnlineForm handleClick={ this.addOnlineForm } formType="ucrse_2019" title="Universal CRS-E Form" /></div>
            <div className="form"><OnlineForm handleClick={ this.addOnlineForm } formType="crscp" title="CRS-CP Form" /></div>
            <div className="form"><OnlineForm handleClick={ this.addOnlineForm } formType="ucrscp_2019" title="Universal CRS-CP Form" /></div>
            <div className="form"><OnlineForm handleClick={ this.addOnlineForm } formType="crsi" title="CRS-I Form" /></div>
            <div className="form"><OnlineForm handleClick={ this.addOnlineForm } formType="ucrsi_2023" title="Universal CRS-I Form" /></div>
            <div className="form"><OnlineForm handleClick={ this.addOnlineForm } formType="w8bene_2021" title="W-8BEN-E Form" /></div>
            <div className="form"><OnlineForm handleClick={ this.addOnlineForm } formType="w8ben_2021" title="W-8BEN Form" /></div>
            <div className="form"><OnlineForm handleClick={ this.addOnlineForm } formType="w8imy_2021" title="W-8IMY Form" /></div>
            <div className="form"><OnlineForm handleClick={ this.addOnlineForm } formType="w9_2024" title="W-9 Form" /></div>
            <div className="form"><OnlineForm handleClick={ this.addOnlineForm } formType="w8eci_2021" title="W-8ECI Form" /></div>
            <div className="form"><OnlineForm handleClick={ this.addOnlineForm } formType="w8exp_2023" title="W-8EXP Form" /></div>
            <div className="form"><OnlineForm handleClick={ this.addOnlineForm } formType="fatca_crsi_2023" title="FATCA/CRS-I Form" /></div>
            <div className="form"><OnlineForm handleClick={ this.addOnlineForm } formType="fatca_crse_2023" title="FATCA/CRS-E Form" /></div>
            <div className="form"><OnlineForm handleClick={ this.addOnlineForm } formType="rc519" title="RC-519 Form" /></div>
            <div className="form"><OnlineForm handleClick={ this.addOnlineForm } formType="rc518" title="RC-518 Form" /></div>
          </div>
        </form>
      </div>
    );
  }
}

const OnlineReduxForm = reduxForm({
  form: 'onlineForm',
})(OnlineForms);

function mapStateToProps(state) {
  const { forms: {
    isAddingOnlineForm
  } } = state;
  return {
    isAddingOnlineForm
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withContainerErrorBoundary(OnlineReduxForm, 'OnlineForms'));
